import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

const AREAS = ["Atlanta", "Peachtree City", "Fayetteville", "Alpharetta", "Marietta", "Riverdale", "Jonesboro", "McDonough", "Stockbridge"];
const SERVICES = [
  { id: "residential", name: "Residential" },
  { id: "deep", name: "Deep Cleaning" },
  { id: "movein", name: "Move-In/Out" },
  { id: "office", name: "Office" },
  { id: "airbnb", name: "Airbnb Turnover" },
  { id: "mold", name: "Mold Remediation" },
  { id: "carwash", name: "Car Detailing" },
];

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white" data-testid="footer">
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_premium-clean-atl/artifacts/x1iqqas7_ShoNics%20Logo.jpg"
              alt="ShoNics Kleaning Solutions"
              className="h-24 w-auto object-contain bg-white p-3 rounded-2xl"
            />
          </div>
          <p className="font-serif text-2xl leading-tight italic text-white/80">
            "We Don't Just Clean —<br /> We <span className="gold-shimmer-text not-italic">Restore Freshness.</span>"
          </p>
          <div className="mt-8 space-y-3 text-sm text-white/70">
            <a href="tel:9432450462" className="flex items-center gap-3 hover:text-[#D4AF37]" data-testid="footer-phone">
              <Phone className="w-4 h-4" /> 943-245-0462
            </a>
            <div className="flex items-center gap-3"><Mail className="w-4 h-4" /> shonicscleaningsolutions@gmail.com</div>
            <div className="flex items-center gap-3"><MapPin className="w-4 h-4" /> Metro Atlanta, GA</div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.24em] text-[#D4AF37] mb-5">Services</div>
          <ul className="space-y-2.5 text-sm text-white/70">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="hover:text-white">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.24em] text-[#D4AF37] mb-5">Service Areas</div>
          <ul className="space-y-2.5 text-sm text-white/70 grid grid-cols-2">
            {AREAS.map((a) => <li key={a}>{a}</li>)}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.24em] text-[#D4AF37] mb-5">Connect</div>
          <div className="flex gap-3">
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#D4AF37] hover:text-black hover:border-transparent transition-all"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#D4AF37] hover:text-black hover:border-transparent transition-all"><Facebook className="w-4 h-4" /></a>
          </div>
          <div className="mt-6 text-xs text-white/40">Insured · Bonded · Eco-friendly</div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} ShoNics Kleaning Solutions. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/admin/login" className="hover:text-[#D4AF37]" data-testid="footer-staff-portal">Staff Portal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
